import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = [{
  title: 'Cardio Excesivo',
  desc: "Eleva tu cortisol, dándole a tu cuerpo la orden de 'guardar grasa abdominal' para protegerse."
}, {
  title: 'Dietas de 1,200 Calorías',
  desc: 'Ralentizan tu tiroides porque tu cuerpo detecta una hambruna artificial.'
}, {
  title: "Productos 'Zero Sugar' en USA",
  desc: 'Destruyen tu microbiota, bloqueando la eliminación del estrógeno viejo.'
}, {
  title: 'Ayuno Mal Hecho',
  desc: 'Confunde tu reloj biológico, arruinando tu sueño y disparando el hambre nocturna.'
}];
export function FailedApproaches() {
  return <section className="py-20 px-6 md:px-12 bg-cream" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-15">
            Por qué lo que has intentado no funcionó
          </h2>
          <p className="text-lg text-gray-600" data-id="element-16">
            No es tu culpa. Estabas usando las herramientas equivocadas para
            esta etapa de tu vida.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-17">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm flex items-start gap-4 border-l-4 border-coral" data-id="element-18">
              <XCircle className="text-coral shrink-0 mt-1" size={28} data-id="element-19" />
              <div data-id="element-20">
                <h3 className="font-bold text-xl text-charcoal mb-2 line-through decoration-coral/50" data-id="element-21">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-22">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}